import React from "react";
import "./WhatsAppWidget.css";

const WHATSAPP_NUMBER = "923316204332";

const WhatsAppWidget = () => {
  const whatsappUrl = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent("Hi! I need help with my Ramzan Scholarship application.")}`;

  return (
    <a
      href={whatsappUrl}
      target="_blank"
      rel="noopener noreferrer"
      className="wa-widget"
      aria-label="Chat with us on WhatsApp"
    >
      <span className="wa-widget__icon">
        <svg viewBox="0 0 32 32" width="32" height="32" xmlns="http://www.w3.org/2000/svg">
          <path fill="#FFFFFF" d="M16.004 0h-.008C7.178 0 0 7.18 0 16c0 3.5.94 6.68 2.998 9.32L1.004 31.3l6.16-1.62A15.9 15.9 0 0 0 16.004 32C24.822 32 32 24.82 32 16S24.822 0 16.004 0zm8.75 22.15c-.48 1.36-2.52 2.48-4.2 2.64-.98.08-2.36.08-3.88-.48-.4-.14-.94-.32-1.62-.58-3.24-1.2-5.74-4.34-6.16-4.92-.42-.58-1.74-2.38-1.74-4.52 0-2.14 1.1-3.22 1.5-3.66.4-.44.86-.54 1.14-.54.28 0 .56 0 .82.02.28.02.66-.1 1.04.8.38.92 1.18 3.34 1.32 3.62.14.28.28.64.08 1.04-.2.4-.32.64-.6.98-.28.34-.58.74-.24 1.42.34.68 1.26 2.18 2.74 3.4 1.9 1.56 3.46 2.06 3.94 2.3.48.26.76.22 1.04-.14.28-.38 1.18-1.5 1.5-2.02.32-.52.64-.44 1.06-.28.42.16 2.68 1.34 3.16 1.6.48.26.8.4.92.62.12.22.12 1.28-.36 2.64z"/>
        </svg>
      </span>
      <span className="wa-widget__tooltip">Chat with us on WhatsApp</span>
    </a>
  );
};

export default WhatsAppWidget;
